import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'charactersLeft'
})
export class CharactersLeftPipe implements PipeTransform {
  transform(value: string, total: number): number {
    return total - value.length;
  }
}
